// src/utils/errors.ts

/**
 * Extrae un mensaje legible de los distintos formatos de error del backend:
 *  - { message }                     → endpoints /admin/** y login
 *  - { mensaje }                     → ResponseExceptionHandler (CustomException, 404…)
 *  - { error_message }               → MercadoPagoException
 *  - { campo: "mensaje", ... }       → errores de validación (@Valid)
 */
export function getErrorMessage(err: any, fallback = "Ocurrió un error inesperado. Inténtalo de nuevo."): string {
  if (err?.code === "ECONNABORTED") return "El servidor tardó demasiado en responder. Inténtalo de nuevo.";
  if (err?.message === "Network Error") return "No hay conexión con el servidor de Toinup.";

  const data = err?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data && typeof data === "object") {
    const msg = data.message || data.mensaje || data.error_message;
    if (typeof msg === "string" && msg.trim()) return msg;
    if (typeof data.error === "string" && data.error.trim()) return data.error;
    const firstValue = Object.values(data).find((v) => typeof v === "string" && (v as string).trim());
    if (firstValue) return firstValue as string;
  }
  if (err?.response?.status === 403) return "No tienes permisos para realizar esta acción.";
  return fallback;
}
